module.exports = __webpack_public_path__ + "img/fire-flame-01.6d9439c8.png";